import React, { Component } from 'react';
import { Tabs } from 'antd';
import { GeneralSection } from './GeneralSection';
import { CoinSpecificStratsSection } from './CoinSpecificStratsSection';
import { CoinSelectionSection } from './CoinSelectionSection';
import { DangerZoneSection } from './DangerZone';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
const TabPane = Tabs.TabPane;

@withRouter
@inject('store')
@observer
export class SettingsView extends Component {
    render() {
        return (
            <div>
                <Tabs defaultActiveKey="1" tabPosition={'left'}>
                    <TabPane tab="General" key="1">
                        <GeneralSection />
                    </TabPane>
                    <TabPane tab="Coin Selection" key="2">
                        <CoinSelectionSection />
                    </TabPane>
                    <TabPane tab="Coin Specific Strats" key="3">
                        <CoinSpecificStratsSection />
                    </TabPane>
                    <TabPane tab="Danger Zone" key="4">
                        <DangerZoneSection />
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SettingsView/index.js